module.exports = __webpack_public_path__ + "img/accepted_card_logos.ad2dd2a.jpg";